import { render } from "./AuthForm.vue?vue&type=template&id=7c29dbf8&ts=true&lang=pug"
import script from "./AuthForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__